{
  "name": "demf-data-discovery",
  "version": "3.1.2",
  "description": "Search for datasets and open data resources on the web",
  "private": false,
  "type": "module",
  "engines": {
    "node": ">=22.0.0 <23 || >=24.8.0 <25"
  },
  "scripts": {
    "predev": "node ./scripts/generate-vuetify-locales.mjs",
    "dev": "concurrently \"vite build --watch --mode development\" \"vite preview --port 9014\"",
    "prebuild": "node ./scripts/generate-vuetify-locales.mjs",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint . --fix",
    "format": "prettier --write src/"
  },
  "dependencies": {
    "@mdi/font": "^7.4.47",
    "axios": "^1.15.0",
    "pinia": "^3.0.4",
    "single-spa-vue": "^3.0.1",
    "vue": "^3.5.32",
    "vue-i18n": "^11.3.2",
    "vue-router": "^5.0.4",
    "vuetify": "^3.12.5"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@vitejs/plugin-vue": "^6.0.6",
    "@vue/eslint-config-prettier": "^10.2.0",
    "concurrently": "^9.2.1",
    "eslint": "^10.2.1",
    "eslint-plugin-vue": "^10.8.0",
    "globals": "^17.5.0",
    "prettier": "^3.8.2",
    "vite": "^8.0.9",
    "vite-plugin-css-injected-by-js": "^5.0.1"
  }
}
